import { render, staticRenderFns } from "./IncomeReport.vue?vue&type=template&id=1bd3ed11&scoped=true&"
import script from "./IncomeReport.vue?vue&type=script&lang=ts&setup=true&"
export * from "./IncomeReport.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./IncomeReport.vue?vue&type=style&index=0&id=1bd3ed11&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3ed11",
  null
  
)

export default component.exports